const parseJSON = <T>(value: string | null): T | undefined =>
  value === 'undefined' ? undefined : JSON.parse(value ?? '');

export const localStorageApiFactory = (storage: Storage) => {
  const fallbackStorage: Record<string, unknown> = {};

  const get = <T>(key: string, defaultValue?: T) => {
    try {
      return (
        (fallbackStorage[key] as T | undefined) ?? parseJSON<T>(storage.getItem(key))
      );
    } catch {
      return defaultValue;
    }
  };

  const set = <T>(key: string, value: T) => {
    try {
      storage.setItem(key, JSON.stringify(value));
      delete fallbackStorage[key];
    } catch {
      fallbackStorage[key] = value;
    }
  };

  const remove = (key: string) => {
    try {
      storage.removeItem(key);
    } catch {
      delete fallbackStorage[key];
    }
  };

  const clear = () => {
    try {
      storage.clear();
    } catch {
      Object.keys(fallbackStorage).forEach(key => delete fallbackStorage[key]);
    }
  };

  return {
    get,
    set,
    remove,
    clear
  };
};
